export default {
  attachmentItemComponent: 'attachment-item',
  anchorEditor: true,
  anchorPreview: true,
  attributeInserter: true,
  allowMediaInserter: false,
  textFormatter: true,
  allowFilePaste: false,
  allowUploads: false,
  allowMention: false,
  allowAlignment: false,
  allowAttachments: false,
  allowAttribute: true,
  allowBold: true,
  allowItalic: true,
  allowAnchor: true,
  allowHeading: false,
  allowMarkdownHeadings: false,
  allowMarker: false,
  allowSubheading: false,
  allowOrderedList: true,
  allowUnorderedList: true,
  allowImage: false,
  allowVideoFile: true,
  allowButton: false,
  allowVideo: false,
  allowSocial: false,
  allowCode: false,
  allowHtml: false,
  allowEmoji: true,
  readOnly: false,
  displaySocialBlocksAsButtons: false,
  urlReplacement: false,
  markdownLinks: false,
  markdownInlineCode: false,
  autoFocusTopLeft: false,
  allowedVideoTypes: ['video/mp4'],
  recoverErrors: true,
  allowRtl: false,
  stripEmptyTrailingBlocks: true
};